import { WIDGET_COLORS } from '../constants/colors';
import { formatDate, formatPoints } from '../utils/formatSavingsPoints';

type Props = {
  sentDate: string;
  expiryDate: string;
  pointsEarned: string;
};

export function DipTimeline({ sentDate, expiryDate, pointsEarned }: Props) {
  return (
    <div
      className="flex rounded-[10px] px-4 py-3 mt-3.5"
      style={{ backgroundColor: WIDGET_COLORS.dip.bg }}
    >
      <TimelineItem value={formatDate(sentDate)} label="DIP Form Sent" first />
      <TimelineItem value={formatDate(expiryDate)} label="Valid Until" />
      <TimelineItem value={`${formatPoints(pointsEarned)} pts`} label="Points Earned" />
    </div>
  );
}

function TimelineItem({ value, label, first }: { value: string; label: string; first?: boolean }) {
  return (
    <div
      className={`flex-1 flex flex-col ${first ? '' : 'pl-4'}`}
      style={first ? undefined : { borderLeft: `1px solid ${WIDGET_COLORS.dip.divider}` }}
    >
      <span className="text-[15px] font-bold leading-[1.2]" style={{ color: WIDGET_COLORS.dip.text }}>
        {value}
      </span>
      <span
        className="text-sm font-semibold uppercase tracking-[0.5px] mt-0.5"
        style={{ color: WIDGET_COLORS.dip.labelText }}
      >
        {label}
      </span>
    </div>
  );
}
